import { EntityType } from '../../definitions/types/Entity';
import { StateType } from '../../definitions/types/StateType';
import { WORKSPACE_URL } from '../../utils/constants/WORKSPACE_URL';

export const urlFromState = ({
  entities,
  selected,
  workspaceClearUrl,
}: StateType): string => {
  if (!selected || !entities.length) return workspaceClearUrl;
  const urlEntities: string = entities
    .map((entity: EntityType) => `${entity.type}:${entity.id}`)
    .join(',');
  const urlSelected: string = `${selected.type}:${selected.id}`;
  return `${WORKSPACE_URL}?entities=${urlEntities}&selected=${urlSelected}`;
};
